import { Injectable } from "@angular/core";
import { AuthenticationRepository } from "../data/repository";
import { Permissions } from "../common";

@Injectable({
    providedIn: 'root'
})
export class UserPermissionService {
    constructor(private authenticationRepository: AuthenticationRepository){}

    isHasPermission(permissions: Array<Permissions>): boolean {
        if (!this.authenticationRepository.currentUser$.value || !permissions || permissions.length === 0) {
            return false;
        }
        const userPermissions = this.authenticationRepository.currentUser$.value.permissions;    
        return permissions.some(allowedPermission => userPermissions.includes(allowedPermission));
    }
}